import { noAuthSagas } from "./no-auth/sagas";
import { sagaMiddleware } from "./store";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function runNoAuthSagas() {
  sagaMiddleware.run(noAuthSagas);
}
